import React, {Component, useEffect, useState} from 'react';
import {Button, Col, Image, Label, Panel, Row} from 'react-bootstrap';
import {Redirect, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';


const DesignOrderCard = ({order}) => {
    const [skus, set_skus] = useState(order.skus);
    const [redirect,set_redirect] = useState(false);
    const [redirect_url,set_redirect_url] = useState(null);

    var fetch_sku_images = async () => {
        try {
            var updated_skus = await Promise.all(skus.map(async sku => {            
                var resp
                if (sku.type === '123rf_image') {
                    resp = await fetch(global.config.server_path + 'design_resource/load_123rf_resource', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({id: sku.rf_image, design_id: sku.design, quality:'m'})})
                    resp = await resp.json();
                } else if (sku.type === '123rf_plus_image') {
                    resp = await fetch(global.config.server_path + 'design_resource/load_123rf_plus_resource', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({id: sku.rf_plus_image, design_id: sku.design, quality:'m'})})
                    resp = await resp.json();
                } else if (sku.type === 'design_resource') {
                    resp = await fetch(global.config.server_path + 'design_resource/load_design_resource', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({id: sku.design_resource, design_id: sku.design, quality:'m'})})
                    resp = await resp.json();
                } else if (sku.type === 'pixlr_image') {
                    resp = await fetch(global.config.server_path + 'design_resource/load_pixlr_resource', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({id: sku.pixlr_image, design_id: sku.design, quality:'m'})})
                    resp = await resp.json();
                }
                sku.image_src = resp.data.src;
                return sku;
            }));
            set_skus(updated_skus);
        } catch(err) {
            console.log(err);
        }
    }

    const redirect_page = (url) => {
        set_redirect_url(url);
        set_redirect(true);
    };

    const get_image_src = src => {

        if (!src) {
            return '';
        }
        if (src.indexOf('data:image')>-1 || src.indexOf('http')>-1 || src.indexOf('blob:')>-1) {
            if(src.indexOf('blob:')>-1 || src.indexOf('data:image')>-1){
                return src;
            }else{
                return global.config.server_path.replace('api/','')+'api/image_proxy?src='+window.encodeURIComponent(src)
            }
        } else {
            return global.config.server_path + src;
        }
    };

    useEffect(() => {
        fetch_sku_images()
    }, [order]);

    if(redirect){
        return (<Redirect push to={redirect_url}/>)
    }else{
        return (
            <Panel>
                <Panel.Heading style={{backgroundColor: '#f1f2f3', backgroundImage: 'none', paddingTop: 14, paddingBottom: 14}}>
                    <span><Label style={{padding: 8, fontWeight: 500, backgroundColor: '#f1f2f3', color: 'black'}} ><span style={{fontSize: 14}}>Order ID - {order._id}</span></Label></span>
                    <span className="pull-right"><Label style={{padding: 8, fontWeight: 500, backgroundColor: '#f1f2f3', color: 'black'}} ><span style={{fontSize: 14}}>Placed on {new Date(order.createdAt).toDateString()}</span></Label> </span>                        
                </Panel.Heading>
                <Panel.Body>
                    {skus.map(sku => (
                        <Row style={{paddingTop: 5, paddingBottom: 5}}>
                            <Col xs={4} align="center">
                                <Image onClick={() => redirect_page('/designmaker/start/designs/'+sku.design+'/edit')} style={{maxHeight: 150, maxWidth: '100%', objectFit: 'contain'}} src={get_image_src(sku.image_src)} />
                            </Col>
                            <Col xs={8}>
                                <Row style={{padding: '5px'}}>
                                    <Col xs={6} align="left">
                                        <b>Premium Image</b>
                                        <br />
                                        <span className={sku.license === 'single' ? "fa fa-user" : "fa fa-users"}/> &nbsp; {sku.license} license purchased
                                    </Col>
                                    <Col xs={6} align="right">
                                        <b>Item Price - ${sku.price} USD</b>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    ))}
                </Panel.Body>
                <Panel.Footer style={{backgroundColor: '#f1f2f3', backgroundImage: 'none'}}>
                    <Row style={{fontWeight: 'bold'}}>
                        <Col xs={6} className="text-left">Order Total</Col>
                        <Col xs={6} className="text-right">${order.amount} USD</Col>
                    </Row>
                </Panel.Footer>
            </Panel>
        )
    }

}


class DesignOrders extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            order_history : [],
        }
    }

    componentDidMount() {
        this.fetch_order_history();
    }

    fetch_order_history = async () => {
        try {
            var _url = global.config.server_path+'user/fetch_order_history/';
            var order_history = await fetch(_url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include' });
            order_history = await order_history.json();
            order_history = order_history.data.filter(x => (x.skus && x.skus.length && x.skus[0].type !== 'mockup' && x.status == 'fulfilled'));
            this.setState({ order_history });
            order_history.map(async order => {
                try {
                    await Promise.all(order.skus.map(async sku => {
                        try {
                            var resp
                            if (sku.type === '123rf_image') {
                                resp = await fetch(global.config.server_path + 'design_resource/load_123rf_resource', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({id: sku.rf_image, design_id: sku.design, quality:'m'})})
                                resp = await resp.json();
                                if (resp.response_code === 1) {
                                    this.setState({ [sku['rf_image']]: resp.data.src })
                                }
                            }else if (sku.type === '123rf_plus_image') {
                                resp = await fetch(global.config.server_path + 'design_resource/load_123rf_plus_resource', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({id: sku.rf_plus_image, design_id: sku.design, quality:'m'})})
                                resp = await resp.json();
                                if (resp.response_code === 1) {
                                    this.setState({ [sku['rf_plus_image']]: resp.data.src })
                                }
                            } else if (sku.type === 'design_resource') {
                                resp = await fetch(global.config.server_path + 'design_resource/load_design_resource', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({id: sku.design_resource, design_id: sku.design, quality:'m'})})
                                resp = await resp.json();
                                if(resp.response_code === 1){
                                    this.setState({ [sku['design_resource']] : resp.data.src })
                                }
                            }else if (sku.type === 'pixlr_image') {
                                resp = await fetch(global.config.server_path + 'design_resource/load_pixlr_resource', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({id: sku.pixlr_image, design_id: sku.design, quality:'m'})})
                                resp = await resp.json();
                                if (resp.response_code === 1) {
                                    this.setState({ [sku['pixlr_image']]: resp.data.src })
                                }
                            }
                            return 1;
                        } catch(err) {
                            return Promise.reject(err);
                        }
                    }));                    
                } catch(err) {
                    return Promise.reject(err);
                }
            })
        } catch(err) {
            console.log('error fetching order history --> ', err)
        }
    } 

    download_file = src => {
        var download = window.document.createElement('a');
        download.href = src
        download.download = 'mockup.png'
        download.click();
    }

    list_order_history = () => {
        var order_list = []
        for (let i=0; i < this.state.order_history.length; i++) {
            for (let j = 0; j < this.state.order_history[i].skus.length; j++) {
                const sku = this.state.order_history[i].skus[j];
                if (sku.type === 'mockup') {
                    let order_card = (
                        <Col xs={12}>
                        <Panel style={{padding:'5px','border':'none'}}>
                            <Row style={{padding: '5px'}}>
                                <Col xs={12} align="center">
                                    <Image style={{'width':'50%'}} src={global.config.server_path + sku.output_file}/>
                                </Col>
                            </Row>
                            <Row style={{padding: '5px'}}>
                                <Col xs={3}>
                                </Col>
                                <Col xs={3}>
                                    <p>Placed on {new Date(this.state.order_history[i].createdAt).toDateString()}<br />
                                    {this.state.order_history[i].amount} USD</p>
                                </Col>
                                <Col xs={3} align="right">
                                    <Button target="blank" onClick={() => {this.download_file(global.config.server_path + sku.output_file)}} className="btn btn-sm btn-orange">Download Now</Button> 
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Panel>
                        </Col>);
                    order_list.push(order_card)        
                } else if (sku.type === '123rf_image') {
                    let order_card = (
                    <Col xs={12}>
                        <Panel style={{padding:'5px','border':'none'}}>
                            <Row style={{padding: '5px'}}>
                                <Col xs={12} align="center">
                                    <Image style={{'width':'50%'}} src={this.state[sku.rf_image]?global.config.server_path+this.state[sku.rf_image]:""}/>
                                </Col>
                            </Row>
                            <Row style={{padding: '5px'}}>
                                <Col xs={3}>
                                </Col>
                                <Col xs={3}>
                                    <p>Placed on {new Date(this.state.order_history[i].createdAt).toDateString()}<br />
                                    {this.state.order_history[i].amount} USD</p>
                                </Col>
                            </Row>
                        </Panel>
                        </Col>);
                    order_list.push(order_card)
                } else if (sku.type === '123rf_plus_image') {
                    let order_card = (
                    <Col xs={12}>
                        <Panel style={{padding:'5px','border':'none'}}>
                            <Row style={{padding: '5px'}}>
                                <Col xs={12} align="center">
                                    <Image style={{'width':'50%'}} src={this.state[sku.rf_plus_image]?global.config.server_path+this.state[sku.rf_plus_image]:""}/>
                                </Col>
                            </Row>
                            <Row style={{padding: '5px'}}>
                                <Col xs={3}>
                                </Col>
                                <Col xs={3}>
                                    <p>Placed on {new Date(this.state.order_history[i].createdAt).toDateString()}<br />
                                    {this.state.order_history[i].amount} USD</p>
                                </Col>
                            </Row>
                        </Panel>
                        </Col>);
                    order_list.push(order_card)
                }  else if (sku.type === 'pixlr_image') {
                    let order_card = (
                    <Col xs={12}>
                        <Panel style={{padding:'5px','border':'none'}}>
                            <Row style={{padding: '5px'}}>
                                <Col xs={12} align="center">
                                    <Image style={{'width':'50%'}} src={this.state[sku.pixlr_image]?global.config.server_path+this.state[sku.pixlr_image]:""}/>
                                </Col>
                            </Row>
                            <Row style={{padding: '5px'}}>
                                <Col xs={3}>
                                </Col>
                                <Col xs={3}>
                                    <p>Placed on {new Date(this.state.order_history[i].createdAt).toDateString()}<br />
                                    {this.state.order_history[i].amount} USD</p>
                                </Col>
                            </Row>
                        </Panel>
                        </Col>);
                    order_list.push(order_card)
                } else if (sku.type === 'design_resource') {
                    var order_card = (
                    <Col xs={12}>
                        <Panel style={{padding:'5px','border':'none'}}>
                            <Row style={{padding: '5px'}}>
                                <Col xs={12} align="center">
                                    <Image style={{'width':'50%'}} src={this.state[sku.design_resource]?global.config.server_path + this.state[sku.design_resource]: ""}/>
                                </Col>
                            </Row>
                            <Row style={{padding: '5px'}}>
                                <Col xs={3}>
                                </Col>
                                <Col xs={3}>
                                    <p>Placed on {new Date(this.state.order_history[i].createdAt).toDateString()}<br />
                                    {this.state.order_history[i].amount} USD</p>
                                </Col>
                            </Row>
                        </Panel>
                        </Col>);
                    order_list.push(order_card)
                }
            }
        }
        return order_list.length?order_list:<div>You don't have any past orders!</div>;
    }


    render() {

        if (!this.props.user) {
            // console.log('not authenticated.')
            return <Redirect to="/designmaker/start"/>
        }
        // console.log(this.state.order_history)

        return(
            <div>
                <Row style={{'borderTop': '1px solid #e6e6e6'}}>
                    <Col xs={12} style={{height: 'calc(100vh - 75px)', overflowY: 'scroll'}}>
                        <Row style={{'height': '5vh', 'padding': '20px', 'fontSize':'x-large', textAlign: 'center'}}>
                            <b>Your Orders</b>
                        </Row>
                        <Row style={{'padding': '20px'}}>
                            {this.state.order_history.length>0?this.state.order_history.map(order => (
                                <Col xs={12}>
                                    <DesignOrderCard order={order} />
                                </Col>
                            )):(
                                <Col xs={12}>
                                    <h3 align="center">You don't have any purchases. All your purchases within designmaker will be seen here.</h3>
                                </Col>
                            )}                        
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }

}

const mapStateToProps = function(state) {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DesignOrders));